export default "__VITE_ASSET__BnCURVqS__"